module.exports = __webpack_public_path__ + "static/media/mode-18.30a3972e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-18.svg
// module id = 991
// module chunks = 2